export default {
  id: 228,
  title: 'Target #228 - Another Tree',
  url: 'https://cssbattle.dev/play/228',
  colors: ['#D2F8FF', '#072949', '#3F8090'],
  solution:
    '<p a><p b><p c><p d><p e><style>p[a],p[c]{left:140;width:120;height:120}p[b],p[c]{background:#072949}p[d],p[e]{top:148;width:140;height:190;background:#d2f8ff}body,p[d],p[e]{background:#d2f8ff}p{position:fixed;margin:0}p[a]{top:30;border-radius:1in;background:#3f8090}p[b]{top:90;left:180;width:40;height:60}p[c]{top:150}p[d]{left:220;border-radius:0 0 0 100%}p[e]{right:220;border-radius:0 0 100%',
}
